import { useMemo } from 'react'

import { useDefaultLayoutProps } from '../../layouts/DefaultLayout/useProps'

import { LoaderTemplateProps } from './index'

export const useLoaderPageProps = (): LoaderTemplateProps => {
  const layoutProps = useDefaultLayoutProps()

  return useMemo(
    () => ({
      layout: layoutProps,
    }),
    [layoutProps]
  )
}
